<!--
* UIID: 
* UI Name: Folder Manager
* Modify Date: 2020/10/07
-->
<template>
  <div class="container folder-container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12" lg="2" md="2">
        <v-toolbar-title class="font-bold">Folder</v-toolbar-title>
      </v-col>
      <v-col cols="12" lg="10" md="10" class="text-right pa-0 pr-3">
        <v-btn text height="30" class="folder-btn-bg-color mr-1">Back</v-btn>
        <v-btn text icon height="30" class="mr-1" @click="change2List()">
          <v-icon small :color="this.listColor">fa fa-list</v-icon>
        </v-btn>
        <v-btn text icon height="30" class="" @click="change2Grid($event)">
          <v-icon small :color="this.gridColor">fa fa-th</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Content Section -->
    <v-row class="ml-0 mr-0">
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col cols="12" lg="3" md="3" class="folder-section pa-0">
            <!-- // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function -->
            <folderList :foldList="foldList" @queryRighttList="queryRighttList($event)" @queryLeftList="queryLeftList()" ref="folderList"></folderList>
          </v-col>
          <v-col cols="12" lg="9" md="9" class="pt-0 pb-0 pr-0 file-section">
            <component :is="selectedComponent" :listData="listData" :resetPage="resetPage"></component>
            <!-- <fileList :items="listData"></fileList> -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import folderList from "@/vue-caas/views/folder/FolderList.vue";
import fileList from "@/vue-caas/views/folder/FileList.vue";
import fileTableList from '@/vue-caas/views/folder/FileTableList.vue'
import { mapState } from "vuex";
export default {
  components: {
    folderList,
    fileList,
    fileTableList,
  },

  data: () => ({
    folderData: Array,
    // listData: Array,
    listColor:'secondary',
    gridColor:'secondary',
    selectedComponent: '',
    resetPage: "",
    rightItems: {
        header: ['USER_ID','FOLD_ID'],
        data: [{
          USER_ID: '',
          FOLD_ID: ''
        }]
      },
    leftItems: {
      header: ["USER_ID"],
      data: [
        {
          USER_ID: ""
        }
      ]
    },
    foldList: []
  }),

  computed: {
     isGridView() {
      return this.gridView?"":"d-none";
    },

    isListView() {
      return this.listView?"":"d-none";
    },
    listData(){
      return this.fileList;
    }
  },

  created() {
    // this.$store.dispatch("getFileList");
    // this.listData = this.$store.getters.fileList;
    this.queryLeftList();
    this.queryRighttList();
    this.change2Grid();
  },

  methods: {
     change2List() {
      const params = {};
      this.listColor="primary";
      this.gridColor="secondary";
      this.selectedComponent = 'fileTableList';
    },

    change2Grid() {
      const params = {};
      this.listColor="secondary";
      this.gridColor="primary";
      this.selectedComponent = 'fileList';
    },
    queryLeftList() {
      this.leftItems.data[0].USER_ID = this.$cookies.get("user-id");
      // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
      this.$store.dispatch("queryFolderList", this.leftItems).then(() => {
        this.foldList = this.$store.getters.foldList;
        console.log("Foler List",this.foldList)
      });
    },
    queryRighttList(item){
      if (item == undefined) {
        this.rightItems.data[0].FOLD_ID = "0000000000";
      } else {
        this.rightItems.data[0].FOLD_ID = item.id;
        this.resetPage = item.id;
      }
      this.rightItems.data[0].USER_ID = this.$cookies.get('user-id');
      // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
      // Store.dispatch("mapbuilder/queryFileList", this.rightItems).then(() =>{
      //   this.$refs.folderList.expandAllTreeView();
      // });
    },  
  }
};
</script>
<style lang="scss">

.title-grid-folder{
  font-size: 16px;
  line-height:30px;
}
.file-section{
  padding-left: 30px !important;
}
.folder-card-section .analyzedTree.v-treeview .v-treeview-node__children .v-treeview-node__root{
  width: 300px;
}
.theme--light .folder-card-section.v-card{
  background-color:#FAFCFF;
  border: 1px solid #F0F7FB;
}
.theme--dark .folder-card-section.v-card{
  background-color:#3b3e49;
}
.theme--light .folder-btn-bg-color{
  background: #A9BECB
}
.theme--dark .page-control-content.folder-pagination {
    background: #232329;
}
.theme--light .page-control-content.folder-pagination {
    background: #edf3fc;
    .page-control-bg{
      background: #edf3fc;
    }
}
@media screen and (max-width: 1920px)and (min-width: 1280px){
  .folder-card-section .date-query-section .d-inline-flex {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .folder-section .analyzedTree.v-treeview{
    min-height: 663px;
    max-height: 664px;
    overflow-y: auto;
    overflow-x: auto;
    max-width: 100%;
  }
  .folder-card-section .grid-file-view {
    min-height: 618px;
    max-height: 619px;
    overflow-y: auto;
    overflow-x: auto;
    max-width: 100%;
  }
}
@media screen and (max-width: 1279px) and (min-width: 1024px){
  .folder-card-section .date-query-section .d-inline-flex {
      flex: 0 0 100% !important;
      max-width: 100% !important;
  }
  .folder-section .analyzedTree.v-treeview{
    min-height: 463px;
    max-height: 464px;
    overflow-y: auto;
    overflow-x: auto;
    max-width:187px;
  }
  .folder-card-section .grid-file-view { // -45px
    min-height: 418px;
    max-height: 419px;
    overflow-y: auto;
    overflow-x: auto;
  }
  .folder-card-section .btn-search{
    width: 90px;
  }
}
@media screen and (max-width: 1023px){
  .title-grid-folder{
    margin-bottom:10px
  }
  .file-section{
    padding-left: 0 !important;
    margin-top: 10px;
    .grid-file-view .col-md-4{
      flex: 0 0 50% !important;
      max-width: 50% !important;
    } 
  }
  .folder-section .analyzedTree.v-treeview, .folder-card-section .grid-file-view {
    min-height: 300px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
    max-width: 100%;
  }
  section.content-section .folder-container {
    height: calc(100% + 400px) !important;
  }
  .page-control-content.folder-pagination {
    height: 45px;
  }
}
</style>